import React from 'react'
import { ThemeProvider } from 'styled-components'
import theme from '../styles/theme'
import { ShopifyProvider } from '../contexts/shopify'

/**
 * @throws {Error}
 * @return {undefined}
 */
const Provider = ({ stores, children }) => {
  return (
    <ThemeProvider theme={theme}>
      <ShopifyProvider stores={stores}>{children}</ShopifyProvider>
    </ThemeProvider>
  )
}

export default Provider
